import baseURL from "../config/api";
import axios from "../config/axios";

export const post_Practice = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}exercises?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_Practice = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}exercises?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const getPracticeBySubLesson = (subLessonId: number) => {
    return getFetch(`exercises/GetExercisesBySubLessonId/${subLessonId}`);
}

export const getExercise = (exerciseId: number) => {
    return getFetch(`exercises/${exerciseId}`);
}

export const delete_Practice = (primaryId: number, userId:number) => {
    return axios({
        url: `${baseURL}exercises?id=${primaryId}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}


export const delete_ContentRelatedExcercise = (ids: number[], userId:number) => {
    return axios({
        url: `${baseURL}contentRelatedExercises/DeleteBulkContentRelatedExercise?userId=${userId}`,
        method: "DELETE",
         withCredentials: false,
        data: ids
    }).then(response => response.data);
}

export const delete_BulkVideoRelatedExcercise = (ids: number[], userId:number) => {
    return axios({
        url: `${baseURL}videoRelatedExercises/DeleteBulkVideoRelatedExercise?userId=${userId}`,
        method: "DELETE",
           headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: ids
    }).then(response => response.data);
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}
